export default {
  subject: 'soggetto',
  email: 'e-mail',
  name: 'name',
  message: 'Messaggio',
  password: "parola d'ordine",
  repeatPassword: 'ripeti la password',
  username: 'nome utente',
  country: 'nazione',
  console: 'consolle',
  position: 'posizione',
  newPassword: 'nuova password',
  passwordConfirmation: 'conferma la nuova password',
  title: 'titolo',
  idOrUsername: 'id o nome utente',
  period: 'periodo',
  description: 'descrizione',
  videoCode: 'codice video',
  order: 'ordine',
  type: 'genere',
  teamDowns: "Nombre d'équipes en baisse",
  teamLiguilla: 'Numero di squadre che passano ala liguilla',
  cardNumber: 'numero di carta',
  expirationDate: 'data di scadenza',
  cardMonth: 'mese',
  cardYear: 'anno',
}
